import React, { useState, useRef, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import theme from '../../../style/theme'
// import ResponsiveImage from '../../ResponsiveImage'
import { sliceMarginStyles, span } from '../../../style/span'
// import SplitWordsAnimation from '../../SplitWordsAnimation'
import { vw } from '../../../style/vw'
// import cn from 'classnames'
import Slider from '../../Slider'
import Tile from './Tile'
import ResponsiveImage from '../../ResponsiveImage'
import RichText from '../../RichText'
import cn from 'classnames'
import { useHoverCursor } from '../../Cursor'
import gsap from 'gsap'

const FLICKITY_OPTIONS = {
  cellAlign: 'left',
  pageDots: false,
  contain: true,
  freeScroll: false
}

export default function FeaturesSlice ({ slice }) {
  const { slides } = slice
  const classes = useStyles()
  const [slideIndex, setSlideIndex] = useState(0)
  const slide = slides?.[slideIndex]
  const titlesRef = useRef()
  const slideImageRef = useRef()

  useHoverCursor(titlesRef, true)

  // Add animation effect when slideIndex changes
  useEffect(() => {
    if (slideImageRef.current) {
      // Set initial state slightly down and fade
      gsap.set(slideImageRef.current, { y: 10, opacity: 0.7 })
      // Animate to final position with upward motion
      gsap.to(slideImageRef.current, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'expo.out'
      })
    }
  }, [slideIndex])

  return (
    <>
      <section className={classes.container}>
        <div className={classes.slideTitles} ref={titlesRef}>
          {slides?.map((slide, i) => (
            <div key={i} className={cn(classes.slideTitle, slideIndex === i && 'selected')} onMouseEnter={() => setSlideIndex(i)}>{slide.title}</div>
          ))}
        </div>
        <div className={classes.slideCopy}>
          <RichText content={slide?.copy?.text} />
        </div>
        <div className={classes.slideImage}>
          <ResponsiveImage {...slide.image} aspect={320 / 420} ref={slideImageRef} showCaption={false} />
          <span className={classes.slideImageCaption}>{slide.image?.title ?? ''}</span>
        </div>
      </section>
      <Slider className={classes.slide} flickityOptions={FLICKITY_OPTIONS}>
        {slides?.map((slide, i) => (
          <Tile key={i} image={slide.image} title={slide.title} copy={slide.copy?.text} />
        ))}
      </Slider>
    </>
  )
}

const useStyles = createUseStyles({
  container: {
    extend: [sliceMarginStyles],
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      paddingLeft: span(1, 'md'),
      paddingRight: span(1, 'md')
    }
  },
  slideTitles: {
    [theme.breakpoints.up('md')]: {
      width: span(6, 'md'),
      cursor: 'pointer'
    }
  },
  slideTitle: {
    display: 'block',
    fontFamily: theme.fonts.headings,
    fontWeight: theme.fonts.headingsFontWeight,
    paddingBottom: vw(10, 'desktop'),
    paddingTop: vw(10, 'desktop'),
    borderBottom: [1, 'solid', theme.colors.primary],
    opacity: 0.2,
    transition: 'opacity 0.2s ease-in-out',
    '&.selected': {
      opacity: 1
    },
    [theme.breakpoints.up('md')]: {
      fontSize: vw(20, 'desktop')
    }
  },
  slideCopy: {
    fontSize: vw(16),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(16, 'desktop'),
      paddingLeft: span(2, 'md'),
      width: span(8, 'md')
    }
  },
  slideImage: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: span(2, 'md'),
      width: span(8, 'md')
    }
  },
  slideImageCaption: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      marginTop: vw(10, 'desktop'),
      fontSize: vw(14, 'desktop')
    }
  },
  slide: {
    display: 'block',
    padding: [span(1), span(1), span(2)],
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
})
